(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["evildog-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('evildog-bundles-v4')) {
  customElements.define('evildog-bundles-v4', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.data = JSON.parse(this.querySelector('.edb-data').textContent);
      this.scope = this.closest('.shopify-section');
      if (!this.scope || !this.data.variants.length) {
        this.showError('Bundle setup incomplete. Place this block in Product information, beside Buy buttons.');
        return;
      }
      this.scope.classList.add('edb-active');
      this.quantity = 1;
      this.phoneModels = [1,2,3].map(count => Array(count).fill(''));
      this.busy = false;
      this.money = new Intl.NumberFormat(this.data.locale, {style:'currency',currency:this.data.currency});
      const first = this.data.variants.find(v => v.id === this.data.defaultId && v.available) || this.data.variants.find(v => v.available) || this.data.variants[0];
      this.selections = [1,2,3].map(count => Array.from({length:count}, () => first));
      this.render();
      window.addEventListener('click', event => {
        const button = event.target.closest?.('button, input[type="submit"]');
        if (!button || button.type !== 'submit' || !this.ownsForm(button.form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submitBundle(button.form, button);
      }, {capture:true,signal:this.controller.signal});
      window.addEventListener('submit', event => {
        if (!this.ownsForm(event.target)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submitBundle(event.target, event.submitter);
      }, {capture:true,signal:this.controller.signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.scope?.classList.remove('edb-active');
    }
    ownsForm(form) {
      if (!form || !this.isConnected || form.closest('.shopify-section') !== this.scope) return false;
      if (!form.matches('form[action*="/cart/add"]')) return false;
      const component = form.closest('product-form-component');
      if (component?.dataset.productId !== this.dataset.productId) return false;
      return this.scope.querySelector('evildog-bundles-v4') === this;
    }
    node(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    }
    showError(message) {
      const error = this.querySelector('.edb-error');
      error.textContent = message;
      error.hidden = !message;
    }
    render() {
      const offers = this.querySelector('.edb-offers');
      offers.replaceChildren();
      this.selections.forEach((selected, tier) => {
        const count = tier + 1;
        const discount = [0,10,15][tier];
        const active = count === this.quantity;
        const card = this.node('div','edb-card');
        card.dataset.selected = String(active);
        const label = this.node('label','edb-choice');
        const radio = this.node('input');
        radio.type = 'radio';
        radio.name = `edb-${this.data.sectionId}-${this.data.productId}`;
        radio.value = String(count);
        radio.checked = active;
        radio.addEventListener('change', () => {this.quantity=count;this.render();this.querySelector(`input[value="${count}"]`).focus();});
        const title = this.node('span','edb-title',`Buy ${count}`);
        title.append(this.node('span','edb-save',discount ? `Save ${discount}%` : 'Regular price'));
        const total = selected.reduce((sum,v) => sum+v.price,0);
        const discounted = selected.reduce((sum,v) => sum+Math.round(v.price*(100-discount)/100),0);
        const price = this.node('span','edb-price',this.money.format(discounted/100));
        if(discount) price.append(this.node('s','',this.money.format(total/100)));
        label.append(radio,title,price);
        const items = this.node('div','edb-items');
        items.hidden = !active;
        selected.forEach((variant, index) => {
          const item = this.node('div','edb-item');
          item.append(this.node('p','edb-item-title',`Case ${index+1}`));
          const phoneWrap = this.node('div','edb-phone-wrap');
          const phoneLabel = this.node('label','edb-phone-label','Phone model (required)');
          const phone = this.node('input','edb-phone');
          phone.type = 'text';
          phone.id = `edb-phone-${this.data.sectionId}-${tier}-${index}`;
          phone.dataset.phoneIndex = String(index);
          phoneLabel.htmlFor = phone.id;
          phone.placeholder = 'e.g. iPhone 15 Pro Max';
          phone.autocomplete = 'off';
          phone.required = active;
          phone.minLength = 3;
          phone.maxLength = 50;
          phone.value = this.phoneModels[tier][index];
          phone.addEventListener('input', () => {
            this.phoneModels[tier][index] = phone.value;
            phone.removeAttribute('aria-invalid');
            phone.setCustomValidity('');
          });
          phoneWrap.append(phoneLabel,phone);
          item.append(phoneWrap);
          this.data.options.forEach((option, optionIndex) => {
            if(this.data.options.length === 1 && option === 'Title' && variant.options[0] === 'Default Title') return;
            const field = this.node('fieldset','edb-field');
            field.append(this.node('legend','',option));
            const pills = this.node('div','edb-pills');
            const values = [...new Set(this.data.variants.map(v => v.options[optionIndex]))];
            values.forEach((value,valueIndex) => {
              const button = this.node('button','edb-pill',value);
              button.type='button';
              button.dataset.focusKey=`${tier}-${index}-${optionIndex}-${valueIndex}`;
              button.setAttribute('aria-pressed',String(variant.options[optionIndex]===value));
              const candidates = this.data.variants.filter(v => v.available && v.options[optionIndex]===value);
              button.disabled = !candidates.length;
              button.addEventListener('click', () => {
                const exact = candidates.find(v => v.options.every((val,i) => i===optionIndex || val===variant.options[i]));
                this.selections[tier][index]=exact || candidates[0];
                const key = button.dataset.focusKey;
                this.render();
                this.querySelector(`[data-focus-key="${key}"]`)?.focus();
              });
              pills.append(button);
            });
            field.append(pills);
            item.append(field);
          });
          items.append(item);
        });
        card.append(label,items);
        offers.append(card);
      });
    }
    async submitBundle(form, button) {
      const locks = this.constructor.locks ||= new Map();
      const lockKey = this.dataset.sectionId + ':' + this.dataset.productId;
      if (locks.has(lockKey)) return;
      const selected = this.selections[this.quantity-1];
      if(selected.some(v => !v.available)) {this.showError('This selection is sold out. Please choose another variant.');return;}
      const models = this.phoneModels[this.quantity-1].map(value => value.trim());
      const invalid = models.findIndex(value => value.length < 3 || value.length > 50);
      if (invalid !== -1) {
        this.showError(`Enter the exact phone model for Case ${invalid+1}.`);
        const input = this.querySelector(`.edb-items:not([hidden]) [data-phone-index="${invalid}"]`);
        input.setAttribute('aria-invalid','true');
        input.setCustomValidity('Enter your exact phone model (3–50 characters).');
        input.focus();
        input.reportValidity();
        return;
      }
      const formData = new FormData(form);
      if(formData.get('selling_plan')) {this.showError('Bundles are available for one-time purchases only.');return;}
      const properties = {};
      for(const [key,value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if(match && typeof value === 'string' && !/^phone[ _-]*model$/i.test(match[1])) properties[match[1]]=value;
        if(match && typeof value !== 'string' && value.size) {this.showError('File uploads are not supported in this bundle.');return;}
      }
      const items = selected.map((v,index) => ({id:v.id,quantity:1,properties:{...properties,'Phone Model':models[index]}}));
      locks.set(lockKey, true);
      this.busy=true;
      this.showError('');
      const submitter = button || form.querySelector('[type="submit"]');
      if(submitter) {submitter.disabled=true;submitter.setAttribute('aria-busy','true');}
      try {
        const root = this.data.root.endsWith('/') ? this.data.root : this.data.root+'/';
        const response = await fetch(root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if(!response.ok) {
          this.showError((result.description || result.message || 'Could not add your bundle.') + ' Check your cart before trying again.');
          const link = this.node('a','', ' View cart');
          link.href = this.data.cart;
          this.querySelector('.edb-error').append(link);
          return;
        }
        window.location.assign(this.data.cart);
      } catch(error) {
        this.showError('We could not confirm the cart update. Check your cart before trying again to avoid duplicate cases.');
        const link = this.node('a','', ' View cart');
        link.href = this.data.cart;
        this.querySelector('.edb-error').append(link);
      } finally {
        this.busy=false;
        if(submitter) {submitter.disabled=true;submitter.removeAttribute('aria-busy');}
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
